export const theme = {
  color: {
    primary: "#555555",
    grey: "#555555",
  },
  mediaQueries: {
    mobile: "@media (max-width: 37.5em)",
    desktop: "@media (max-width: 75em)",
    small_mobile: "@media (max-width: 25em)",
    tablet: "@media (max-width: 56.25em)",
    large_desktop: "@media (max-width: 112.5em)",
  },
}

export const activityCategories = {
  ARCADE: "arcade",
  BOWLING: "bowling",
  LASER_GAME: "laseGame",
  PAINT_BALL: "paintBall",
  ESCAPE_GAME: "escapeGame",
}

export const activitySlotTypes = {
  "30_MINUTES": "30 Minutes",
  "60_MINUTES": "60 Minutes",
  "90_MINUTES": "90 Minutes",
}

// Enums
export enum BookingStatusEnum {
  TO_PAY = "TO_PAY",
  BOOKED = "BOOKED",
  PENDING = "PENDING",
  CANCELED = "CANCELED",
}
export enum BookingSourceEnum {
  WIDGET = "WIDGET",
  HOPLEISURE = "HOPLEISURE",
}

export enum DiscountTypesEnum {
  PERCENTAGE = "PERCENTAGE",
  SUBSTRACTION = "SUBSTRACTION",
}

export enum ActivityPricesStatusEnum {
  ENABLED = "ENABLED",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
}

export enum ActivityPricesTypeEnum {
  DEFAULT = "DEFAULT",
  SENIOR = "SENIOR",
  CHILD = "CHILD",
  GROUP = "GROUP",
}

export enum ActivitySpecialSlotTypesEnum {
  MARK_AS_FULL = "MARK_AS_FULL",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum ActivityTypeEnum {
  GROUP = "GROUP",
  INDIVIDUAL = "INDIVIDUAL",
}

export enum ErrorDiscountEnum {
  MIN_BASKET_NOT_REACHED = "MIN_BASKET_NOT_REACHED",
  DISCOUNT_DATE_RANGE_INVALID = "DISCOUNT_DATE_RANGE_INVALID",
  MAX_AMOUNT_REACHED = "MAX_AMOUNT_REACHED",
  MAX_TICKETS_REACHED = "MAX_TICKETS_REACHED",
  LAST_DAY_DISCOUNT_NOT_REACHED = "LAST_DAY_DISCOUNT_NOT_REACHED",
  DISCOUNT_NOT_FOUND = "DISCOUNT_NOT_FOUND",
}

export const emptyActivity: any = {
  informations: {
    description: null,
    maxCapacity: 1,
    slotDuration: 0,
    images: [],
    email: null,
    name: null,
    address: null,
    phone: null,
    cancelation: null,
    category: "ARCADE",
    isEnabled: true,
  },
  hours: {
    hours: {
      "0": {
        slots: [],
      },
      "1": {
        slots: [],
      },
      "2": {
        slots: [],
      },
      "3": {
        slots: [],
      },
      "4": {
        slots: [],
      },
      "5": {
        slots: [],
      },
      "6": {
        slots: [],
      },
    },
  },
  prices: [],
  channels: [],
}

export const listOfPositiveNumber = (number: number) =>
  Array.from(Array(number).keys()).filter((item) => item !== 0)

export enum DATEFORMAT {
  MONTH = "YYYY-MM",
  DAY = "YYYY-MM-DD",
  DATE_TIME = "YYYY-MM-DD HH:mm",
}

export enum ActivityTypeHours {
  HOURS_OPERATIONS = "HOURS_OPERATIONS",
  TIME_SLOTS = "TIME_SLOTS",
}

export const phoneRegex = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/)

export const payzenStyleSheetUrl =
  "https://static.payzen.eu/static/js/krypton-client/V4.0/ext/neon-reset.min.css"

export const defaultGoogleFontUrl =
  "https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap"

export const STALE_TIME_MS = 10000
